var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAndroidAutoAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / logo_android_auto_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.18181082,68 C2.31886034,68 0,65.6592308 0,62.7692308 C0,61.8188654 0.250508167,60.9253846 0.690962087,60.1580962 L33.5091513,2.61963462 C34.4030136,1.05481731 36.0783578,0 38,0 C39.9216422,0 41.5969864,1.05481731 42.4908487,2.61963462 L75.3090379,60.1580962 C75.7494918,60.9253846 76,61.8188654 76,62.7692308 C76,65.6592308 73.6811397,68 70.8181892,68 L5.18181082,68 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-21.471%",
    y1: "37.806%",
    x2: "84.198%",
    y2: "97.817%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.02,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "38 25 67 77.25 65 79 38 68.5483976 10.9392321 79 9 77.25"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-logo_android_auto_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Android-Auto",
    transform: "translate(7.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Android---Fill",
    fill: "#03A9F4",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow---Fill",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "38 25 38 68 81 68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shadow---Fill",
    fill: "#039BE5",
    mask: "url(#mask-2)",
    x: -1,
    y: -1,
    width: 39,
    height: 69
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Auto---Fill",
    fill: "#F1F1F1",
    fillRule: "nonzero",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shadow---Fill",
    fill: "#E1E1E1",
    mask: "url(#mask-5)",
    x: 38,
    y: 24,
    width: 29,
    height: 55
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAndroidAutoAppTile);
export default __webpack_public_path__ + "static/media/logo_android_auto_app_tile.30b0d10738994c833bd404080cea5e9b.svg";
export { ForwardRef as ReactComponent };